import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Root from './route/root'
import registerServiceWorker, { unregister } from './registerServiceWorker';
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import reducer from './redux/index'
import throttle from 'lodash/throttle'
import { saveState, loadState } from './storage/index'

const presistanceState = loadState()
const store = createStore(reducer, presistanceState)

store.subscribe(throttle(() => {
    saveState({
        login: store.getState().login,
    })
}), 1000)

ReactDOM.render(
    <Provider store={store} >
        <Root />
    </Provider>
    , document.getElementById('root'));
// registerServiceWorker();
unregister()



// WEBPACK FOOTER //
// ./src/index.js